import { format } from "date-fns";

export function formatDateTime(datetime) {
    if (datetime)
        return format(new Date(datetime), 'dd MMM yyyy HH:mm:ss')
    else return '-'
};